<div class="skeleton-page">
    <div class="container container--small">
        <div class="row skeleton-page__top">
            <div class="col-md-5 change-color skeleton-page__area"></div>
            <div class="col-md-6"></div>
            <div class="col-md-1 change-color skeleton-page__area"></div>
        </div>
        <div class="row change-color skeleton-page__message"></div>
        <div class="row">
            <div class="col change-color skeleton-page__area skeleton-page__area-spc"></div>
            <div class="col change-color skeleton-page__area skeleton-page__area-spc"></div>
            <div class="col change-color skeleton-page__area skeleton-page__area-spc"></div>
            <div class="col change-color skeleton-page__area skeleton-page__area-spc"></div>
            <div class="col change-color skeleton-page__area"></div>
        </div>
        <div class="row change-color skeleton-page__jump-area"></div>
        <div class="row change-color skeleton-page__jump-area"></div>
        <div class="row change-color skeleton-page__jump-area"></div>
        <div class="row change-color skeleton-page__jump-area"></div>
        <div class="row spcp-bt">
            <div class="col-md-3"></div>
            <div class="col-md-6 change-color skeleton-page__area"></div>
            <div class="col-md-3"></div>
        </div>
    </div>
</div>
